import { websockets } from '../../../engine/websockets-sidecar'
import { chessTestParams } from '../chessTestParams-sidecar'
import { chessWebsockets_extensions } from './chessWebsockets_extensions-sidecar'

export function getIsSingleplayer() {
  return websockets.getIsSingleplayer()
}
export function getMultiId() {
  return websockets.getMultiId()
}
export function getMultiName() {
  return websockets.getMultiName()
}
export function getPingTime() {
  return websockets.getPingTime()
}
export function getIsHost() {
  return websockets.getIsHost()
}

export function create() {
  websockets.create(chessWebsockets_extensions, chessTestParams.serverVersion)
  websockets.tryConnect()
}
